import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=1068c52d&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=1068c52d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068c52d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
